import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="Y" transform="translate(11.000000, 5.000000)">
        <path
        d="M 27.16 27.58 L 27.65 40.6 L 28.21 46.2 L 33.88 47.6 L 33.53 50.4 L 24.29 49.7 L 14.91 50.4 L 15.05 47.6 L 20.58 46.34 L 20.93 40.67 L 21.14 29.33 L 9.1 8.96 L 4.9 4.06 L 0 2.8 L 0.35 0 L 9.52 0.7 L 19.32 0 L 19.18 2.8 L 14.14 3.92 L 16.17 8.89 L 21.49 17.92 L 25.06 24.64 L 25.34 24.64 L 28.77 18.55 L 34.79 8.75 L 36.61 3.64 L 31.57 2.8 L 31.92 0 L 39.83 0.7 L 47.32 0 L 47.18 2.8 L 42.07 3.92 L 38.5 8.89 L 27.16 27.58 Z"
        fill="currentColor"
        transform="translate(15, 20)"  
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
